import { useFormValidationAlert } from '@op/luna.yaweb-common-js/FormValidationAlert';
import { useContext } from 'react';
import { InsuranceOfferContext } from '../context';
import ValidateContactInfoQuestions from '../validators/ValidateContactInfoQuestions';

export const useInsuranceOffer = () => {
  const [state, setState] = useContext(InsuranceOfferContext);

  const { errors, addErrors, removeErrors } = useFormValidationAlert();

  // Updates state and validates the new values. Sets errors to <FormValidationAlert />
  const updateStateAndErrors = (prevState, action) => {
    const nextState = { ...prevState, ...action };
    // Let's call insurance type specific validator
    const newErrors = action.insurance.validator(
      action.insurance.id,
      action.questions,
      false,
      action.questionId
    );

    addErrors(...newErrors.add);
    removeErrors(...newErrors.remove);
    return nextState;
  };

  // Updates contactInfo state and validates the new values. Sets errors to <FormValidationAlert />
  const updateStateAndErrorsContact = (prevState, action) => {
    const nextState = { ...prevState, ...action };

    const newErrors = ValidateContactInfoQuestions(
      action.questions,
      false,
      action.questionId,
      action.getMessage,
    );

    addErrors(...newErrors.add);
    removeErrors(...newErrors.remove);
    return nextState;
  };
  // validates the all values entered in the form
  const validateAll = (validate, getMessage) => {
    let success = true;
    var i;
    for (i = 0; i < state.selectedInsurances.length; i++) {
      const newErrors = state.selectedInsurances[i].validator(
        state.selectedInsurances[i].id,
        state.selectedInsurances[i].questions,
        true,
        '',
        errors,
        state.selectedInsurances[i].caption,
        getMessage
      );
      if (newErrors.add.length > 0) {
        success = false;
      }

      addErrors(...newErrors.add);
      removeErrors(...newErrors.remove);
    }

    if (validate === 'all') {
      const newErrorsContact = ValidateContactInfoQuestions(
        state.contactInfo,
        true,
        '',
        getMessage
      );

      addErrors(...newErrorsContact.add);
      removeErrors(...newErrorsContact.remove);

      if (newErrorsContact.add.length > 0) {
        success = false;
        return success;
      }
    }
    return success;
  };

  const validateInsurance = (action) => {
    const prevState = updateStateAndErrors(state, action);
    setState(prevState, action);
  };

  const validateContactInfo = (action) => {
    const prevState = updateStateAndErrorsContact(state, action);
    setState(prevState, action);
  };

  const createOrDeleteInsurance = (action) => {
    if (
      action.type === 'IO_DELETE_INSURANCE_TARGET' ||
      action.type === 'IO_DELETE_ALL_INSURANCES'
    ) {
      const newErrors = { add: [], remove: [] };
      const deleteKey = {
        IO_DELETE_INSURANCE_TARGET: 'id',
        IO_DELETE_ALL_INSURANCES: 'type',
      };
      const insuranceList = state.selectedInsurances.filter(
        (item) => item[deleteKey[action.type]] !== action.insuranceId
      );
      const insuranceLength = insuranceList.length;

      newErrors.remove = errors
        .filter(
          ({ id }) =>
            !insuranceLength || (insuranceLength && !id.startsWith('CONTACT_'))
        )
        .map(({ id }) => id);

      insuranceList.forEach((record, insuranceIndex) => {
        newErrors.add = [
          ...newErrors.add,
          ...errors
            .filter(({ id }) => id.startsWith(record.id))
            .map(({ id, message }) => {
              const errorIdList = id?.split('_');
              let [prefix] = errorIdList;
              errorIdList[0] = prefix.replace(/[0-9]/g, insuranceIndex + 1);
              return { id: errorIdList.join('_'), message };
            }),
        ];
      });

      addErrors({ id: 'set_no_scroll' });
      removeErrors(...newErrors.remove);
      addErrors(...newErrors.add);
      removeErrors('set_no_scroll');
      setState(action);
    } else {
      setState(action);
    }
  };

  const updateSendValue = (action) => {
    setState(action)
  };

  // Set `state.showInsurances` to true 
  const setShowInsurancesTrue = () => {
    setState({ type: 'IO_CHANGE_SHOWCQUESTIONS' });
  };

  const validateInsuranceAndContactInfo = (action, getMessage) => {
    return validateAll(action, getMessage);
  };

  const validateAllInsurance = (action, getMessage) => {
    if (state.selectedInsurances.length < 1) {
      setState({ state, ...action }, action);
      return false;
    } else {
      action = { type: 'IO_CHANGE_SHOWCQUESTIONS' };
      setState({ state, ...action }, action);
      return true;
    }
  };

  const validateAllContactInfo = (action, getMessage) => {
    const nextState = { state, ...action };
    if (validateAll('questionsOnly', getMessage) === true) {
      setState(nextState, action);
      return true;
    } else {
      return false;
    }
  };

  return {
    state,
    validateInsurance,
    createOrDeleteInsurance,
    validateContactInfo,
    validateInsuranceAndContactInfo,
    validateAllInsurance,
    validateAllContactInfo,
    updateSendValue,
    setShowInsurancesTrue
  };
};
